<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="dialog-content">
  <div cdkDragHandle class="primary whole-width" mat-dialog-title>
    <div class="dialog-title">{{ pickerDialog.titleLabel }}</div>
    <div class="dialog-buttons fxl-row fxla-start-center">
      @if (pickerDialog.multipleSelectionFlag) {
        <button
          (click)="setCloseModeHandler()"
          [attr.aria-label]="pickerDialog.unpinnedByDefaultFlag ? 'Épingler (Maintenir Ctrl)' : 'Détacher (Relâcher Ctrl)'"
          [matTooltip]="pickerDialog.unpinnedByDefaultFlag ? 'Épingler (Maintenir Ctrl)' : 'Détacher (Relâcher Ctrl)'"
          class="icon-button-fix-alignment small-icon-button"
          mat-icon-button
        >
          @if (pickerDialog.unpinnedByDefaultFlag) {
            <mat-icon mat-icon-button svgIcon="svg_pin"></mat-icon>
          }
          @if (!pickerDialog.unpinnedByDefaultFlag) {
            <mat-icon mat-icon-button svgIcon="svg_unpin"></mat-icon>
          }
        </button>
      }
      <button
        (click)="close()"
        [attr.aria-label]="'Fermer [Échap]'"
        class="icon-button-fix-alignment small-icon-button"
        mat-icon-button
        matTooltip="Fermer [Échap]"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content>
    <div class="fxl-column fxla-center-center">
      <div class="whole-width fxsa-start fxl-row fxla-center-flex-start">
        <div class="whole-width fxl-column fxla-start-stretch-mw">
          <div class="mt-4 fxl-row-wrap fxla-start-end">
            <app-grid-filter
              #_gridFilterComponent
              (textFilterChangedEvent)="textFilterChangedEventHandler($event)"
              [accentThemeFlag]="true"
              [gridFilter]="gridFilter"
              [matLabel]="pickerDialog.textFilterMatLabel"
              [maxlength]="pickerDialog.textFilterMaxlength"
              class="fxf-1-0-80px-rw"
            ></app-grid-filter>

            @if (pickerDialog.textFilter2Flag) {
              <app-grid-filter
                (textFilterChangedEvent)="textFilter2ChangedEventHandler($event)"
                [accentThemeFlag]="false"
                [gridFilter]="gridFilter2"
                [matLabel]="pickerDialog.textFilter2MatLabel"
                [maxlength]="pickerDialog.textFilter2Maxlength"
                class="ml-8 fxf-1-0-80px-rw"
              ></app-grid-filter>
            }
            @if (pickerDialog.comboOptions?.length > 0) {
              <div class="ml-8 fxf-1-0-80px-rw">
                @if (pickerDialog.comboOptions?.length > 0) {
                  <app-combo
                    #_comboComponent
                    (selectedChange)="changeSelectedContainer($event)"
                    [defaultValue]="pickerDialog.comboDefaultValue"
                    [disabled]="pickerDialog.comboDisableFlag"
                    [eraseButtonFlag]="true"
                    [keySelected]="
                      pickerDialog.state?.filterSelectedContainerUuid
                        ? pickerDialog.state?.filterSelectedContainerUuid
                        : pickerDialog.state?.filterSelectedSubcontainerUuid
                    "
                    [listModeFlag]="true"
                    [matLabel]="pickerDialog.comboMatLabel"
                    [nullableOption]="pickerDialog.comboNullableOption"
                    [options]="pickerDialog.comboOptions"
                  ></app-combo>
                }
              </div>
            }
            @if (pickerDialog.combo2Options?.length! > 0) {
              <div class="fxf-grow-rw">
                @if (pickerDialog.combo2Options?.length! > 0) {
                  <app-combo
                    #_combo2Component
                    (selectedChange)="combo2SelectedChangeHandler($event)"
                    [defaultValue]="pickerDialog.combo2DefaultValue"
                    [disabled]="pickerDialog.combo2DisableFlag"
                    [eraseButtonFlag]="true"
                    [keySelected]="
                      pickerDialog.state?.filter2SelectedContainerUuid
                        ? pickerDialog.state?.filter2SelectedContainerUuid
                        : pickerDialog.state?.filter2SelectedSubcontainerUuid
                    "
                    [listModeFlag]="true"
                    [matLabel]="pickerDialog.combo2MatLabel"
                    [nullableOption]="pickerDialog.combo2NullableOption"
                    [options]="pickerDialog.combo2Options"
                  ></app-combo>
                }
              </div>
            }
          </div>
          @if (pickerDialog && loadedFlag()) {
            <app-list-result
              (elementCreationLinkClickedEvent)="elementCreationLinkClickedEventHandler()"
              [disableCreationFlag]="pickerDialog.disableCreationFlag"
              [elementCreationIcon]="pickerDialog.elementCreationIcon"
              [elementCreationLink]="pickerDialog.elementCreationLink"
              [elementCreationLinkLabel]="pickerDialog.elementCreationLinkLabel"
              [elementCreationMessage]="pickerDialog.elementCreationMessage"
              [existenceFlag]="pickerDialog.existenceFlag"
              [totalCount]="elements()?.length"
            >
              <div class="result-list whole-width" list-result>
                <app-table-wrapper
                  #_tableWrapperComponent
                  (keydownArrowLeftEvent)="keydownArrowLeftEventHandler()"
                  (keydownArrowRightEvent)="keydownArrowRightEventHandler()"
                  [paginatedListState]="$any(pickerDialog.state)"
                  [tableConfig]="tableConfig()"
                  [totalCount]="totalCount()"
                >
                  @for (element of elements(); track element.key) {
                    <tr
                      (afterRowFocusedEvent)="_tableWrapperComponent.afterRowFocusedHandler($event)"
                      (click)="chooseElement(element)"
                      (keydownEnterEvent)="chooseElement(element)"
                      [actionColumnFlag]="false"
                      [checkableRowFlag]="false"
                      [columnThreeGtXsVisibleFlag]="true"
                      [columnTwoXsVisibleFlag]="true"
                      [uuid]="element.key"
                      app-row-element
                      body
                      class="picker-result-list"
                    >
                      <div #cardOne [ngClass]="{ disabled: element.disabledFlag }" data-card-one>
                        <app-grouped-label-card
                          [group]="element.containerLabel"
                          [hat]="element.hat"
                          [hatDisabledFlag]="element.hatDisabledFlag"
                          [hatStyle]="element.hatStyle"
                          [hatWidth]="element.hatWidth"
                          [highlightGroupFlag]="pickerDialog.highlightCol1GroupFlag"
                          [highlightHatFlag]="element.highlightHatFlag"
                          [highlightInfoFlag]="pickerDialog.highlightCol1InfoFlag"
                          [highlightLabelFlag]="pickerDialog.highlightCol1LabelFlag"
                          [highlightSubgroupFlag]="pickerDialog.highlightCol1SubgroupFlag"
                          [info]="element.code"
                          [infoUnspecifiedFlag]="element.codeUnspecifiedFlag"
                          [label]="element.label"
                          [labelDisabledFlag]="element.disabledFlag"
                          [labelUnspecifiedFlag]="element.labelUnspecifiedFlag"
                          [subGroup]="element.subcontainerLabel"
                          [truncatedContentWidth]="pickerDialog.truncatedContentWidth"
                          class="fxf-auto-fill-c"
                        >
                        </app-grouped-label-card>
                      </div>
                      @if (
                        element.col2Group ||
                        element.col2Info ||
                        element.col2Label ||
                        element.col2SubGroup ||
                        element.col2ProgressValue ||
                        element.col2ProgressValue === 0
                      ) {
                        <div #cardTwo [ngClass]="{ disabled: element.disabledFlag }" data-card-two>
                          <app-grouped-label-card
                            [group]="element.col2Group"
                            [highlightGroupFlag]="pickerDialog.highlightCol2GroupFlag"
                            [highlightGroupType]="pickerDialog.highlightCol2GroupType"
                            [highlightInfoFlag]="pickerDialog.highlightCol2InfoFlag"
                            [highlightLabelFlag]="pickerDialog.highlightCol2LabelFlag"
                            [highlightSubgroupFlag]="pickerDialog.highlightCol2SubgroupFlag"
                            [info]="element.col2Info"
                            [label]="element.col2Label"
                            [subGroup]="element.col2SubGroup"
                            class="mb-8"
                          >
                          </app-grouped-label-card>
                          @if (element.col2ProgressValue || element.col2ProgressValue === 0) {
                            <mat-progress-bar
                              bufferValue="{{ element.col2BufferValue ? element.col2BufferValue : 0 }}"
                              class="progress-bar"
                              mode="buffer"
                              value="{{ element.col2ProgressValue }}"
                            ></mat-progress-bar>
                          }
                        </div>
                      }
                      @if (element.col3Group || element.col3Label) {
                        <div #cardThree [ngClass]="{ disabled: element.disabledFlag }" data-card-three>
                          <app-grouped-label-card
                            [group]="element.col3Group"
                            [highlightLabelFlag]="pickerDialog.highlightCol3LabelFlag"
                            [highlightLabelType]="pickerDialog.highlightCol3LabelType"
                            [label]="element.col3Label"
                            class="text-right"
                          >
                          </app-grouped-label-card>
                        </div>
                      }
                    </tr>
                  }
                  <tr class="picker-list-footer" foot>
                    <td colspan="100%">
                      <mat-paginator
                        (page)="updatePaginator($event)"
                        [hidePageSize]="true"
                        [length]="totalCount()"
                        [pageIndex]="pickerDialog.state.pageIndex"
                        [pageSize]="pickerDialog.state.pageSize"
                        [showFirstLastButtons]="true"
                      ></mat-paginator>
                    </td>
                  </tr>
                </app-table-wrapper>
              </div>
            </app-list-result>
          }
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
